module.exports = __webpack_public_path__ + "img/body_bg.e4128240.png";